/* eslint-disable no-unused-vars */
export class WSMessage {
  /**
   * WS Message constructor
   * @param message
   */
  constructor(message) {
    if (this.constructor === WSMessage) {
      throw new Error(' Can\'t instantiate an abstract class.');
    }
    this.message = message;
    this.actions = [];
  }

  isRelevant(state) {
    throw new Error('Method isRelevant not implemented.');
  }

  createActionsForDispatch() {
    return this.actions;
  }
}
